import type { KatexOptions } from "katex";

export const katexOptions: KatexOptions = {
	throwOnError: false,
	macros: { "\\frac": "\\dfrac" },
};

/**
 * Convert LaTeX-style `\[...\]` / `\(...\)` delimiters to the
 * `$$...$$` / `$...$` form that remark-math expects, and normalise
 * Unicode characters that KaTeX cannot parse.
 *
 * Also escapes currency-style `$` (a `$` immediately followed by a digit)
 * so remark-math doesn't pair them up and render the surrounding text
 * as math (e.g. "$237,044) is the reconciliation ... includes $235,929").
 */
export function normalizeMathDelimiters(text: string): string {
	// Skip `\[digits\]` — those are inline citation labels from the backend,
	// not display math. See evidence_markers._inline_numbered_link.
	let result = text.replace(/\\\[(?!\d+\\\])([\s\S]*?)\\\]/g, (_, inner) => `$$${inner}$$`);
	result = result.replace(/\\\(([\s\S]*?)\\\)/g, (_, inner) => `$${inner}$`);
	// Replace Unicode minus (U+2212) with ASCII hyphen-minus inside math delimiters
	result = result.replace(/\$\$[\s\S]*?\$\$/g, (m) => m.replace(/\u2212/g, "-"));
	result = result.replace(/(?<!\$)\$(?!\$)([^$]+)\$(?!\$)/g, (m) => m.replace(/\u2212/g, "-"));
	// Escape currency `$` (followed by a digit) so it isn't parsed as math.
	// Skip already-escaped `\$` and `$$` math delimiters.
	result = result.replace(/(^|[^\\$])\$(?=\d)/g, "$1\\$");
	return result;
}
